var _path, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mail_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .5h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mail_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.23 15.125c-.378 0-.699-.131-.961-.394a1.309 1.309 0 0 1-.394-.962V5.231c0-.38.131-.7.394-.962.262-.263.583-.394.962-.394h11.538c.38 0 .7.131.962.394.263.262.394.583.394.962v8.538c0 .38-.131.7-.394.962a1.309 1.309 0 0 1-.962.394H3.231ZM15 6.082 9.365 9.689a.886.886 0 0 1-.179.077.635.635 0 0 1-.372 0 .886.886 0 0 1-.179-.077L3 6.082v7.687c0 .068.022.123.065.166A.225.225 0 0 0 3.23 14h11.538a.224.224 0 0 0 .166-.065.224.224 0 0 0 .065-.166V6.082ZM9 8.75 14.885 5H3.115L9 8.75ZM3 6.255v-.858.023-.024.859Z",
    fill: "#6D6D6D"
  }))));
};
export default SvgMail;